import { useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { DateTimePicker, SharedDateTimePickerProps } from '../DateTimePicker';
import moment from 'moment';

interface Props extends SharedDateTimePickerProps {
    name: string;
}

export const FormDateTimePicker = ({ name, label, TextFieldProps, ...props }: Props) => {
    const [field, meta] = useField(name);

    const changeHandler = useCallback((date: moment.Moment | null) => {
        const value = date ? date.toISOString() : '';
        field.onChange({ target: { name, value } });
    }, []);

    const textFieldProps = useMemo(
        () =>
            ({
                error: meta.touched && Boolean(meta.error),
                helperText: meta.touched && meta.error,
                size: 'small',
                label,
                ...TextFieldProps,
            } as SharedDateTimePickerProps['TextFieldProps']),
        [TextFieldProps],
    );

    return (
        <DateTimePicker
            value={moment(field.value)}
            TextFieldProps={textFieldProps}
            {...props}
            onChange={changeHandler}
        />
    );
};
